export default __webpack_public_path__ + "static/media/content-delivery-faq-background.b22a4134.png";